import api from './client';

export const getTasks    = (diagramId) => api.get('/gantt', { params: { diagram: diagramId } });
export const createTask  = (data) => api.post('/gantt', data);
export const updateTask  = (id, data) => api.put(`/gantt/${id}`, data);
export const deleteTask  = (id) => api.delete(`/gantt/${id}`);
